// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-modal[data-v-e7ce979c] .el-dialog__body {\n  background: #f7f7f8;\n  padding: 20px;\n  padding-bottom: 100px;\n}\n.order-modal[data-v-e7ce979c] .el-dialog__footer {\n  background: white;\n  border-top: 1px solid #dee3e7;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 1;\n  padding: 10px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
